// extracted by mini-css-extract-plugin
export default {"holderTabsAndFind":"Stats_holderTabsAndFind__0hDOj"};